import { OrderEntity } from './order.entity';

export class OrderStates extends OrderEntity {
  changeStepsCounters() {
    this.TAB_STATES.opened = this.order.querySelectorAll('[data-step]:not(.disabled)').length;
    return this;
  }

  resetState() {
    this.TAB_STATES.step = 1;
    this.TAB_STATES.opened = 1;
    this.TAB_STATES.verifiedStepsCount = 1;
    window.location.hash = 'step-1';
    return this;
  }

  /**
   * @param {OrderStates} state
   * @returns {OrderFormBySteps}
   */
  setState(state) {
    window.location.hash = `step-${state.step}`;
    this.TAB_STATES = state;
    return this;
  }
}
